module.exports = __webpack_public_path__ + "img/app-teacher.dd84b12a.png";